import type { DocumentType } from '@query/services/api/document-manager';

import { type ResourceMeta } from './common-document-types';

const LATEST_VERSION = 1;

// Base fields that don't change
type BaseItemDocument = ResourceMeta & {
  id: string;
  updatedAt: string;
  createdAt: string;
  name: string;
  query: string | null;
  clientId?: string;
};

// Database document type (includes version)
export type ItemDocument = BaseItemDocument & {
  version: typeof LATEST_VERSION;
};

export type ItemDocumentVersions = ItemDocument;

// Application type (no version)
export type Item = Omit<ItemDocument, keyof Pick<ResourceMeta, 'version'>> & { parentId?: string };

export type PartialItem = Omit<Item, 'id' | 'createdAt' | 'updatedAt'> & Partial<Pick<Item, 'id'>>;

export const itemDocumentType: DocumentType<ItemDocumentVersions> = {
  name: 'item',
  currentVersion: LATEST_VERSION,
};
